import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b01834d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row bms-message-attributes" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "dl-horizontal" }
const _hoisted_5 = { class: "bms-attr-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Kategorie", -1))
const _hoisted_7 = { class: "bms-attr-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Zuständig", -1))
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "dl-horizontal" }
const _hoisted_11 = { class: "dl bms-attr-column" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Geokoordinaten", -1))
const _hoisted_13 = { class: "bms-attr-column" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Bei Eingabe gesuchte Adresse", -1))
const _hoisted_15 = { class: "bms-attr-column" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Status", -1))
const _hoisted_17 = { class: "row wdw-actionbar" }
const _hoisted_18 = {
  key: 0,
  class: "col-12"
}
const _hoisted_19 = {
  class: "alert alert-success d-flex align-items-center mt-3",
  role: "alert"
}
const _hoisted_20 = { class: "col-md-6 col-sm-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wdw-actionbar-action-text" }, "Öffentlicher", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wdw-actionbar-action-text" }, "Kommentar", -1))
const _hoisted_23 = { class: "col-md-6 col-sm-6" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wdw-actionbar-action-text" }, "Meldung", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wdw-actionbar-action-text" }, "beobachten", -1))
const _hoisted_26 = {
  key: 1,
  class: "col-12"
}
const _hoisted_27 = {
  class: "alert alert-success d-flex align-items-center mt-3",
  role: "alert"
}
const _hoisted_28 = { key: 2 }

import BmsBoardDetailCreateComment from '@/components/bms/bms_board/BmsBoardDetailCreateComment.vue';
import BmsBoardDetailCreateSubscribe from '@/components/bms/bms_board/BmsBoardDetailCreateSubscribe.vue';
import BmsBoardDetailViewAttachments from '@/components/bms/bms_board/BmsBoardDetailViewAttachments.vue';
import BmsBoardDetailViewHistory from '@/components/bms/bms_board/BmsBoardDetailViewHistory.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import useNumberManip from '@/composables/general/useConverter';
import useUrlParams from '@/composables/general/useUrlParams';
import useAuthentication from '@/composables/user/useAuthentication';
import { messageStore } from '@/store/message-store';
import { userStore } from '@/store/user-store';
import { UrlParams } from '@vueuse/core';
import Skeleton from 'primevue/skeleton';
import { PropType, computed, nextTick, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  params: { type: Object as PropType<UrlParams>, required: true },
},
  emits: ['goBackToOverview'],
  setup(__props, { emit }) {

const props = __props



const { setUrlParams, deleteUrlParams } = useUrlParams();
const { roundDecimals } = useNumberManip();
const { getVirtualUser } = useAuthentication();

const message = computed(() => messageStore.getState().message);
const loading = computed(() => messageStore.getState().loading);
const subscribeDialogActive = ref(false);
const alertSuccess = ref(false);
const successMessage = ref('');
const commentDialogActive = ref(false);
const commentEl = ref();
const subscribeEl = ref();
const errorMessage = ref('');
function openCommentDialog() {
  setUrlParams({ create_dialog: '1' });
  commentDialogActive.value = true;
  if (commentEl.value) {
    nextTick(() => commentEl.value.scrollIntoView({ block: 'start', behavior: 'smooth' }));
  }
}
function openSubscriptionDialog() {
  setUrlParams({ subscribe: '1' });
  subscribeDialogActive.value = true;
  if (subscribeEl.value) {
    nextTick(() => subscribeEl.value.scrollIntoView({ block: 'start', behavior: 'smooth' }));
  }
}

function switchView(component: string, success: boolean) {
  if (success) {
    alertSuccess.value = true;
  }
  if (component == 'subscribe') {
    deleteUrlParams(['subscribe']);
    subscribeDialogActive.value = false;
    successMessage.value = 'Benachrichtigung abonniert.';
  }
  if (component == 'comment') {
    deleteUrlParams(['create_dialog']);
    if (success) {
      successMessage.value =
        'Vielen Dank für Ihren Hinweis. Der öffentliche Kommentar wird an den aktuell Zuständigen der Meldung geschickt. Erst nach einer manuellen Prüfung ist er öffentlich im System sichtbar.';
    }
    commentDialogActive.value = false;
  }
}
function goBackToOverview() {
  emit('goBackToOverview', {}, false);
}
onMounted(() => {
  if (props.params.subscribe) {
    openSubscriptionDialog();
  }
  if (props.params.create_dialog) {
    openCommentDialog();
  }
  messageStore
    .getMessageByMessageId(+props.params.messageid, {
      permissions: 'complete',
      fields:
        'id,message_type,attachments,created,remind_on,responsible,attribute_values,state_german,updates,text,owner,lat,lon,private,state,archived,search_string,related_geometry_names,address,escalate_on,priority',
    })
    .catch((error: any) => {
      errorMessage.value = 'Sie können diese Meldung momentan nicht sehen';
      console.log(error);
    });

  if (!userStore.getState().authToken && process.env.VUE_APP_ENABLE_VIRTUAL_USER) {
    // try to init/get virtual user for eventual anonymous votes/comments/thoughts
    getVirtualUser()
      .then(success => {
        if (!success) {
          console.log('no successinitialized virtual user');
        }
      })
      .catch(e => {
        console.log('error getting virtual user');
      });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(loading) && __props.params && _unref(message))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(WdwDynbox, {
            title: "Beschreibung der Meldung",
            config: { showControls: false },
            minimize: false
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(message).text), 1)
            ]),
            _: 1
          }),
          _createVNode(WdwDynbox, {
            title: "Details",
            config: { showControls: false },
            minimize: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("dl", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("dd", null, _toDisplayString(_unref(message).message_type.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("dd", null, _toDisplayString(_unref(message).responsible.public_name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("dl", _hoisted_10, [
                    _createElementVNode("dl", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("dd", null, _toDisplayString(_unref(roundDecimals)(_unref(message).lat, 4)) + ", " + _toDisplayString(_unref(roundDecimals)(_unref(message).lon, 4)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("dd", null, _toDisplayString(_unref(message).address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("dd", null, _toDisplayString(_unref(message).state_german), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(WdwDynbox, {
            title: "Angehängte Dateien",
            config: { showControls: false },
            minimize: false
          }, {
            default: _withCtx(() => [
              _createVNode(BmsBoardDetailViewAttachments, {
                messageAttachments: _unref(message).attachments
              }, null, 8, ["messageAttachments"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_17, [
            (alertSuccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "check",
                      class: "flex-shrink-0 me-2"
                    }),
                    _createElementVNode("div", null, _toDisplayString(successMessage.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                onClick: openCommentDialog,
                class: "btn btn-primary btn-block btn-lg"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "comments",
                  class: "wdw-actionbar-action-icon"
                }),
                _hoisted_21,
                _hoisted_22
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                onClick: openSubscriptionDialog,
                class: "btn btn-primary btn-block btn-lg"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "bell",
                  class: "wdw-actionbar-action-icon"
                }),
                _hoisted_24,
                _hoisted_25
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", {
            ref_key: "commentEl",
            ref: commentEl
          }, [
            _createVNode(BmsBoardDetailCreateComment, {
              messageid: +props.params.messageid,
              onCancel: _cache[0] || (_cache[0] = ($event: any) => (switchView('comment', false))),
              onSubmit: _cache[1] || (_cache[1] = ($event: any) => (switchView('comment', true)))
            }, null, 8, ["messageid"])
          ], 512), [
            [_vShow, commentDialogActive.value]
          ]),
          _withDirectives(_createElementVNode("div", {
            ref_key: "subscribeEl",
            ref: subscribeEl
          }, [
            _createVNode(BmsBoardDetailCreateSubscribe, {
              messageid: +props.params.messageid,
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (switchView('subscribe', false))),
              onSubmit: _cache[3] || (_cache[3] = ($event: any) => (switchView('subscribe', true)))
            }, null, 8, ["messageid"])
          ], 512), [
            [_vShow, subscribeDialogActive.value]
          ]),
          _createVNode(WdwDynbox, {
            title: "Bearbeitungshistorie",
            config: { showControls: false },
            minimize: false
          }, {
            default: _withCtx(() => [
              _createVNode(BmsBoardDetailViewHistory, {
                messageid: _unref(message).id
              }, null, 8, ["messageid"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_font_awesome_icon, {
              icon: "check",
              class: "flex-shrink-0 me-2"
            }),
            _createElementVNode("div", null, _toDisplayString(errorMessage.value), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: goBackToOverview,
        class: "btn btn-primary"
      }, "zurück zur Übersicht")
    ]),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(_unref(Skeleton), {
            height: "100px",
            class: "mb-3"
          }),
          _createVNode(_unref(Skeleton), {
            height: "300px",
            class: "mb-3"
          }),
          _createVNode(_unref(Skeleton), {
            height: "150px",
            class: "mb-3"
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})